import { fontSize16 } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import {
	green,
  white
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

export const boxInfoFinishedOfferStyle = `
  .title {
    font-size: ${fontSize16};
    font-weight: bold;
  }
  .list {
    padding: 18px;
    li {
      margin-bottom: 5px;
    }
  }
  .link {
    font-size: ${fontSize16};
    color: ${green};
    min-width: 90px;
    border: none;
    height: auto;
    font-size: 14px;
    min-width: 100px;
    background-color: ${white} 
  }
`;
